export default "__VITE_ASSET__AkPsEb09__"